var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-wrapper fire-marshal__contacts" },
    [
      _c("div", { staticClass: "table-caption" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("tenancy.table.fireMarshalContacts")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.allowLinkContacts
        ? _c("div", { staticClass: "link__contact" }, [
            _c(
              "button",
              {
                staticClass: "btn link__contact--btn",
                attrs: { type: "button", disabled: !_vm.tenancyId },
                on: {
                  click: function ($event) {
                    return _vm.linkFunc({ isFireMarshal: true })
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("tenancy.table.linkContact")))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "link__contact--plus" }, [_vm._v("+")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("table", [
        _c("thead", [
          _c(
            "tr",
            [
              _vm._l(_vm.itemHeaders, function (header, index) {
                return _c("th", { key: index, class: header.class }, [
                  _vm._v(_vm._s(header.name)),
                ])
              }),
              _vm._v(" "),
              _c("th"),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.contacts, function (item, index) {
            return _c("tr", { key: index }, [
              _c("td", [
                _vm.canAccessContact
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "name-hyper-link",
                          on: {
                            click: function ($event) {
                              return _vm.navToContactDetail(item.id, true)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.fullName || item.name))]
                      ),
                      _vm._v(" "),
                      _vm.isEngineer
                        ? _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !!item.remarks,
                                expression: "!!item.remarks",
                              },
                            ],
                            staticClass: "remark-included-flag",
                          })
                        : _vm._e(),
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.fullName || item.name) +
                          "\n          "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("isEmptyValue")(item.phone)) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "select-emails" },
                [
                  _c(
                    "HKLForm",
                    { ref: "formRef", refInFor: true },
                    [
                      _c("HKLMultiSelect", {
                        directives: [
                          {
                            name: "fusioninputcheck",
                            rawName: "v-fusioninputcheck",
                            value: {
                              type: "string",
                              required: true,
                              showTip: false,
                            },
                            expression:
                              "{\n                type: 'string',\n                required: true,\n                showTip: false,\n              }",
                          },
                        ],
                        attrs: { value: item.fEmails, options: item.allEmails },
                        on: {
                          change: function (val) {
                            return _vm.updateEmail(item.index, val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "select-role" },
                [
                  _c("HKLSelect", {
                    attrs: { value: item.i18nRole, options: _vm.roleOpts },
                    on: {
                      select: function (val) {
                        return _vm.updateRole(
                          item.index,
                          val,
                          item.fireMarshalRole
                        )
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "input-remarks" },
                [
                  _c("HKLTextarea", {
                    attrs: {
                      value: item.fRemarks,
                      disabled: !_vm.allowLinkContacts,
                    },
                    on: {
                      onChange: function (val) {
                        return _vm.updateRemarks(item.index, val)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("td", { staticClass: "icon-remove" }, [
                _vm.allowLinkContacts
                  ? _c("i", {
                      staticClass: "fa fa-times-thin",
                      on: {
                        click: function () {
                          return _vm.openDelModal(item.index)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "HKLModal",
        {
          ref: "delConfirmModal",
          attrs: { okBtnAction: "yes" },
          on: {
            onOkClick: function ($event) {
              return _vm.removeContact()
            },
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("\n      " + _vm._s(_vm.$t("deleteConfirmMsg")) + "\n    "),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }